import { TranslateService } from "@ngx-translate/core";

import { ParameterTypeEnum } from "@commons/enums/parameter-type.enum";
import { IChartBuildConfigTooltipData } from "@src/app/interfaces/chart-params.interface";
import { formatDate } from "@src/app/utils/date";

interface IGetCustomLabelByValue {
  value_binary: number;
  parameterType: ParameterTypeEnum;
}

export interface ITooltipBuilder {
  formatTooltip(params: any, data: IChartBuildConfigTooltipData[]): string;
};

export class TooltipBuilderCarsParams implements ITooltipBuilder {

  public tooltipConfigParams: { [key: number]: Map<number, string> } = {
    [ParameterTypeEnum.Ignition]: new Map([
      [0, this.translate.instant('disabled')],
      [1, this.translate.instant('enabled')],
    ]),
    [ParameterTypeEnum.Binary]: new Map([
      [0, this.translate.instant('primeng.reject')],
      [1, this.translate.instant('primeng.accept')],
    ]),
  };

  constructor(private translate: TranslateService) {}

  public formatTooltip(params: any): string {
    let tooltip = `${ this.translate.instant('labels.time') }: ${formatDate('HH:mm:ss', new Date(params[0].axisValue))}<br/>`;

    params.forEach((param: any) => {
      if (param.data.parameterType === ParameterTypeEnum.Ignition || param.data.parameterType === ParameterTypeEnum.Binary) {
        tooltip += `<span style="color:${param.color}">●</span> ${param.seriesName}: ${this.getTooltipCustomLabelByValue(param.data)} ${param.data.unit || ''}<br/>`;
      }
      else {
        tooltip += `<span style="color:${param.color}">●</span> ${param.seriesName}: ${param.data.value} ${param.data.unit || ''}<br/>`;
      }
    });
    return tooltip;
  };

  private getTooltipCustomLabelByValue({ value_binary, parameterType }: IGetCustomLabelByValue): string {
    return this.tooltipConfigParams[parameterType].get(value_binary || 0) as string;
  }

};
